import commonRequest from '@/api/v2/common'
import jwt from 'jsonwebtoken'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Router from 'vue-router'
import layouts from '../layout'
// import store from '../store'
import store from '../store/index'
import util from '../util/util'
import getAccessToken from '../util/getAccessToken'
// import LoadingComponent from '../views/pages/loadingComponent'
// import ErrorComponent from '../views/pages/errorComponent'

const FundTransfer = () =>
  lazyLoadView(import('../views/apps/fund-transfer/index.vue'))
const AccountInfo = () =>
  lazyLoadView(import('../views/apps/account-info/AccountInfo.vue'))
const Login = () =>
  lazyLoadView(import('../views/pages/authentication/Login.vue'))
const ForgotPassword = () =>
  lazyLoadView(import('../views/pages/authentication/ForgotPassword.vue'))
const SuccessInfo = () =>
  lazyLoadView(import('../views/pages/success-info.vue'))
const NotFound = () => lazyLoadView(import('../views/pages/NotFound.vue'))
const Setting = () => lazyLoadView(import('../views/apps/setting/setting.vue'))
const Deposit = () => lazyLoadView(import('../views/apps/deposit/index.vue'))
const Records = () => lazyLoadView(import('../views/apps/records/index.vue'))
const Opentrades = () =>
  lazyLoadView(import('../views/apps/open-trades/index.vue'))
const Closetrades = () =>
  lazyLoadView(import('../views/apps/close-trades/index.vue'))
const Withdrawal = () =>
  lazyLoadView(import('../views/apps/withdrawal/index.vue'))
const DepositTypeTab = () =>
  lazyLoadView(import('../views/apps/deposit/deposit-type-tab.vue'))
const UploadDepositReciep = () =>
  lazyLoadView(import('../views/apps/deposit/upload-deposit-reciep.vue'))
const Home = () => lazyLoadView(import('../views/apps/home/Home.vue'))
const ChangePassword = () =>
  lazyLoadView(import('../views/pages/authentication/changePassword.vue'))
const OtherAccount = () =>
  lazyLoadView(import('../views/apps/other-account/index.vue'))
const AccountApplication = () =>
  lazyLoadView(import('../views/apps/other-account/accountApplication.vue'))
const SubAccount = () =>
  lazyLoadView(import('../views/apps/sub-account/index.vue'))
const TradeProduct = () =>
  lazyLoadView(import('../views/apps/trade-product/index.vue'))
const Download = () => lazyLoadView(import('../views/apps/download/index.vue'))
const TableDownload = () =>
  lazyLoadView(import('../views/apps/table-download/index.vue'))
const TradeRecordes = () =>
  lazyLoadView(import('../views/apps/trade-recordes/index.vue'))
const PersonalCenter = () =>
  lazyLoadView(import('../views/apps/personal-center/index.vue'))
const Exchange = () => lazyLoadView(import('../views/apps/exchange/index.vue'))
const Quotes = () => lazyLoadView(import('../views/apps/quotes/index.vue'))
const QuotesApplyForm = () =>
  lazyLoadView(import('../views/apps/quotes/quotesApplyForm.vue'))
const QuotesApplyTerms = () =>
  lazyLoadView(import('../views/apps/quotes/quotesApplyTerms.vue'))
const Bonds = () => lazyLoadView(import('../views/apps/bonds/index.vue'))
const addHKCard = () =>
  lazyLoadView(import('../views/apps/account-info/accountRecords.vue'))
const riskAssessment = () =>
  lazyLoadView(import('../views/apps/other-account/risk-assessment.vue'))
const riskDisclosure = () =>
  lazyLoadView(import('../views/apps/other-account/risk-disclosure.vue'))
const resultFund = () =>
  lazyLoadView(import('../views/apps/other-account/result.vue'))
const riskLevel = () =>
  lazyLoadView(import('../views/apps/other-account/risk-level.vue'))
const riskTip = () =>
  lazyLoadView(import('../views/apps/other-account/risk-tip.vue'))

const derivativesKnowledge = () =>
  lazyLoadView(import('../views/apps/trade-product/derivatives-knowledge.vue'))
const derivativesKnowledgeResult = () =>
  lazyLoadView(import('../views/apps/trade-product/derivatives-knowledge-result.vue'))

const customerConfirmation = () =>
  lazyLoadView(import('../views/apps/trade-product/customer-confirmation.vue'))

/**
 * 处理路由页面切换时，异步组件加载过渡的处理函数
 * @param {Object} AsyncView 需要加载的组件，如 import('@/components/home/Home.vue')
 * @return {Object} 返回一个promise对象
 */
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    // 需要加载的组件 (应该是一个 `Promise` 对象)
    component: AsyncView,
    // 异步组件加载时使用的组件
    // loading: LoadingComponent,
    // 加载失败时使用的组件
    // error: ErrorComponent,
    // 展示加载时组件的延时时间。默认值是 200 (毫秒)
    delay: 100,
    // 如果提供了超时时间且组件加载也超时了，
    // 则使用加载失败时使用的组件。默认值是：`Infinity`
    timeout: 20000
  })
  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      return h(AsyncHandler, data, children)
    }
  })
}

Vue.use(VueI18n)

Vue.use(Router)
const pageRouter = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      layout: layouts.contenOnly
    }
  },
  {
    path: '/logout',
    beforeEnter(to, from, next) {
      // 弹出登陆提示框
      store.commit('setLogoutDialog', true)
    }
  },

  {
    path: '/forgotPassword',
    name: 'forgotPassword',
    component: ForgotPassword,
    meta: {
      layout: layouts.contenOnly
    }
  },
  {
    path: '/successInfo',
    name: 'successInfo',
    component: SuccessInfo,
    meta: {
      layout: layouts.contenOnly
    }
  },
  {
    path: '*',
    name: 'not-found',
    component: NotFound,
    meta: {
      layout: layouts.contenOnly
    }
  }
]
export let constantRouterMap = [
  {
    path: '/',
    icon: 'icon-IC-profile',
    name: 'home',
    component: Home,
    redirect: '/home',
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/home',
    icon: 'icon-IC-profile',
    name: 'home',
    component: Home,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/setting',
    icon: 'icon-IC-profile',
    name: 'setting',
    component: Setting,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/trade-product',
    icon: 'icon-IC-profile',
    name: 'tradeProduct',
    component: TradeProduct,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/account-info',
    icon: 'icon-IC-profile',
    name: 'account-info',
    component: AccountInfo,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/add-hkCard',
    icon: 'icon-IC-profile',
    name: 'add-hkCard',
    component: addHKCard,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/deposit',
    icon: 'icon-IC-profile',
    name: 'deposit',
    component: Deposit,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/withdrawal',
    icon: 'icon-IC-profile',
    name: 'withdrawal',
    component: Withdrawal,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/records',
    icon: 'icon-IC-profile',
    // redirect: '/records/DepositList',
    name: 'records',
    component: Records,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/open-trades',
    icon: 'icon-IC-profile',
    name: 'open-trades',
    component: Opentrades,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/close-trades',
    icon: 'icon-IC-profile',
    name: 'close-trades',
    component: Closetrades,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/fund-transfer',
    icon: 'icon-IC-profile',
    name: 'fund-transfer',
    component: FundTransfer,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/changePassword',
    icon: 'icon-IC-profile',
    name: 'changePassword',
    component: ChangePassword,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/sub-account',
    icon: 'icon-IC-profile',
    name: 'sub-account',
    component: SubAccount,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/other-account',
    icon: 'icon-IC-profile',
    name: 'other-account',
    component: OtherAccount,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/risk-assessment',
    icon: 'icon-IC-profile',
    name: 'risk-assessment',
    component: riskAssessment,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/risk-disclosure',
    icon: 'icon-IC-profile',
    name: 'risk-disclosure',
    component: riskDisclosure,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/risk-level',
    icon: 'icon-IC-profile',
    name: 'risk-level',
    component: riskLevel,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/risk-tip',
    icon: 'icon-IC-profile',
    name: 'risk-tip',
    component: riskTip,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/result',
    icon: 'icon-IC-profile',
    name: 'result',
    component: resultFund,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/account-application',
    icon: 'icon-IC-profile',
    name: 'account-application',
    component: AccountApplication,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/deposit-type-tab',
    icon: 'icon-IC-profile',
    name: 'deposit-type-tab-1',
    component: DepositTypeTab,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/upload-deposit-reciept',
    icon: 'icon-IC-profile',
    name: 'upload-deposit-reciep-1',
    component: UploadDepositReciep,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/download',
    icon: 'icon-IC-profile',
    name: 'download',
    component: Download,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/table-download',
    icon: 'icon-IC-profile',
    name: 'table-download',
    component: TableDownload,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/trade-recordes',
    icon: 'icon-IC-profile',
    name: 'trade-recordes',
    component: TradeRecordes,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/personal-center',
    icon: 'icon-IC-profile',
    name: 'personal-center',
    component: PersonalCenter,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/exchange',
    icon: 'icon-IC-profile',
    name: 'exchange',
    component: Exchange,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/bonds',
    icon: 'icon-IC-profile',
    name: 'bonds',
    component: Bonds,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/quotes',
    icon: 'icon-IC-profile',
    name: 'quotes',
    component: Quotes,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/QuotesApplyForm',
    icon: 'icon-IC-profile',
    name: 'quotesApplyForm',
    component: QuotesApplyForm,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
  {
    path: '/QuotesApplyTerms',
    icon: 'icon-IC-profile',
    name: 'quotesApplyTerms',
    component: QuotesApplyTerms,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ['app']
    }
  },
   {
        path: '/derivatives-knowledge',
        icon: 'icon-IC-profile',
        name: 'derivatives-knowledge',
        component: derivativesKnowledge,
        meta: {
          auth: true,
          layout: layouts.navLeft,
          searchable: true,
          tags: ['app']
        }
      },
      {
        path: '/derivatives-knowledge-result',
        icon: 'icon-IC-profile',
        name: 'derivatives-knowledge-result',
        component: derivativesKnowledgeResult,
        meta: {
          auth: true,
          layout: layouts.navLeft,
          searchable: true,
          tags: ['app']
        }
      },
      {
        path: '/customer-confirmation',
        icon: 'icon-IC-profile',
        name: 'customer-confirmation',
        component: customerConfirmation,
        meta: {
          auth: true,
          layout: layouts.navLeft,
          searchable: true,
          tags: ['app']
        }
      }
]
var router = null
console.log('api--', util.getProfile())
if (!util.getProfile()) {
  router = new Router({
    mode: 'history',
    routes: pageRouter.concat(constantRouterMap)
  })
} else if (!util.getProfile().custom.accountNumber) {
  constantRouterMap = [
    {
      path: '/home',
      icon: 'icon-IC-profile',
      name: 'home',
      component: Home,
      meta: {
        auth: true,
        layout: layouts.navLeft,
        searchable: true,
        tags: ['app']
      }
    },
    {
      path: '/setting',
      icon: 'icon-IC-profile',
      name: 'setting',
      component: Setting,
      meta: {
        auth: true,
        layout: layouts.navLeft,
        searchable: true,
        tags: ['app']
      }
    }
  ]
}

router = new Router({
  mode: 'history',
  routes: pageRouter.concat(constantRouterMap)
})
constantRouterMap[0].dis = true

async function getTokenByCode(code) {
  let params = {
    grant_type: 'authorization_code',
    code: code,
    redirect_uri: process.env.VUE_APP_CALLBACKURL
  }
  let result = await commonRequest.getTokenByCode(params)
  let data = result.data ? result.data : {}
  if (data.access_token && code) {
    localStorage.clear()
    localStorage.setItem('access_token', '')
    localStorage.setItem('access_token', data.access_token)
    store.commit('setAccessToken', data.access_token)
    // router.push('/home')
  }
  return data.access_token
}
router.beforeEach(async (to, from, next) => {
  // console.log(to.query, 'uuuuuu')
  let langMap = {
    'zh-hans': 'cn',
    'zh-hant': 'hk',
    'en': 'en'
  }
  if (to.query.lang) {
    sessionStorage.setItem(
      'language',
      langMap[to.query.lang] || 'cn'
    )
  }
  if (to.path === '/home' && from.path === '/' && to.query.source !== 'pc') {
    let officeParams = to.fullPath.split('?')[1] // 官网携带的参数
    if (officeParams) {
      localStorage.setItem('officeParams', '&' + officeParams)
    }
    if (to.query.code) {
      let token = await getTokenByCode(to.query.code)
      localStorage.setItem('source', 'web')
      if (token) {
        let obj = jwt.decode(localStorage.getItem('access_token'))
        localStorage.setItem('expire', obj.exp)
        next('/home')
      } else {
        window.location.href = `${
          process.env.VUE_APP_AUTH
        }/login.html?client_id=account_center&client_secret=abcd&redirect_uri=${
          process.env.VUE_APP_CALLBACKURL
        }&state=sdfsfs&scope=basic&response_type=code&signup_uri=${
          process.env.VUE_APP_SIGNUP_URI
        }`
        return false
      }
    } else {
      if (!localStorage.getItem('access_token')) {
        if (localStorage.getItem('officeParams')) {
          window.location.href = `${
            process.env.VUE_APP_AUTH
          }/login.html?client_id=account_center&client_secret=abcd&redirect_uri=${
            process.env.VUE_APP_CALLBACKURL
          }&state=sdfsfs&scope=basic&response_type=code&signup_uri=${
            process.env.VUE_APP_SIGNUP_URI
          }${localStorage.getItem('officeParams')}`
        } else {
          window.location.href = `${
            process.env.VUE_APP_AUTH
          }/login.html?client_id=account_center&client_secret=abcd&redirect_uri=${
            process.env.VUE_APP_CALLBACKURL
          }&state=sdfsfs&scope=basic&response_type=code&signup_uri=${
            process.env.VUE_APP_SIGNUP_URI
          }`
        }
      } else {
        next()
      }
      // return false
    }
  } else if (to.query.source === 'pc') {
    getAccessToken().then(res => {
      localStorage.clear()
      localStorage.setItem('source', 'pc')
      localStorage.setItem('access_token', res)
      store.commit('setAccessToken', res)
      next()
    })
  } else {
    next()
  }
  // 判断是token是否过期
  // if (localStorage.getItem('expire') < new Date().getTime() / 1000) {
  //   window.location.href = `${process.env.VUE_APP_AUTH}/login.html?client_id=account_center&client_secret=abcd&redirect_uri=https%3A%2F%2Ftest1.local%3A8080%2Fhome&state=sdfsfs&scope=basic&response_type=code`
  //   return false
  // }
  // if (to.fullPath.substr(0, 3) === '/#!') {
  //   const path = to.fullPath.substr(3)
  //   next(path)
  //   return
  // }
  // if (to.fullPath.substr(0, 2) === '/#') {
  //   const path = to.fullPath.substr(2)
  //   next(path)
  //   return
  // }

  // /*
  // * if redirent to client portal from app
  // * params source=app id_token=xxxxxxxx
  // * so disable toolbar and footer; and skip login
  // */

  // // 设置菜单的位置和头的位置
  // let idToken = ''
  // let accessToken = ''
  const params = util.getHttpQuery()
  let layoutFlag = true
  // // 如果app嵌入
  if (params.source === 'app') {
    layoutFlag = false
    // 记录source的状态
    store.commit('setSource', 'app')
    if (params.showMenu === 'true') {
      layoutFlag = true
    }
    // if (params.id_token && params.access_token) {
    //   idToken = params.id_token
    //   accessToken = params.access_token
    // }
  }
  // localStorage.setItem('id_token', idToken)
  // localStorage.setItem('access_token', accessToken)
  // store.commit('setIdToken', idToken)
  // store.commit('setAccessToken', accessToken)
  // // debugger
  // if (params.source === 'app') {
  //   let loadingInstance = Loading.service({ fullscreen: true })
  //   await util.initData(idToken)
  //   loadingInstance.close()
  // }
  // if (to.path === '/') {
  //   // if (idToken) {
  //   //   window.location.href = '/#/home'
  //   //   return false
  //   // } else {
  //   //   window.location.href = '/#/login'
  //   //   return false
  //   // }
  //   next()
  // } else {
  //   // 说明是想去其他页面的，此时需检查是否登陆
  //   if (to.path !== '/login' || to.path === '/') {
  //     // if (idToken) {
  //     //   next()
  //     // } else {
  //     //   window.location.href = '/#/login'
  //     //   return false
  //     // }
  //     next()
  //   } else {
  //     next()
  //   }
  // }
  if (layoutFlag) {
    store.commit('setLayout', to.meta.layout)
  } else {
    // 如果是app
    store.commit('setLayout', layouts.navApp)
  }
})

router.afterEach((to, from) => {
  setTimeout(() => {
    store.commit('setSplashScreen', false)
  }, 500)
})

export default router
